<template>
    <five-traps-buttons v-if="gameState.zones.chat.buttons.five_traps"></five-traps-buttons>
</template>

<script>
import store from "../../../store";

export default {
    computed: {
        gameState: () => store.getters.getGameState,
    },

    methods: {
        /**
         * Цвет игрока по id
         * @param playerId
         * @return {null|*}
         */
        getPlayerColor(playerId)
        {
            return this.$parent.getPlayerColor(playerId);
        },
    }
}
</script>
